import { db } from "../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";

// Fetch all reviews from Firestore
export const fetchReviews = async () => {
  const docRef = doc(db, "reviews", "AllReviews");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    // Attach _id to each review for easier manipulation
    return Object.entries(data || {}).map(([id, review]) => ({
      ...review,
      _id: id
    }));
  }
  return [];
};

// Fetch only two reviews from Firestore
export const fetchTopReviews = async () => {
  const docRef = doc(db, "reviews", "AllReviews");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    return Object.entries(data || {})
      .slice(0, 2)
      .map(([id, review]) => ({
        ...review,
        _id: id
      }));
  }
  return [];
};

// Add a review to Firestore
export const addReview = async (review) => {
  const reviewId = `review_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
  await setDoc(
    doc(db, "reviews", "AllReviews"),
    { [reviewId]: { ...review, _id: reviewId } },
    { merge: true }
  );
  return reviewId;
};

// Edit a review in Firestore
export const editReview = async (reviewId, updatedReview) => {
  await setDoc(
    doc(db, "reviews", "AllReviews"),
    { [reviewId]: { ...updatedReview, _id: reviewId } },
    { merge: true }
  );
};

// Delete a review from Firestore
export const deleteReview = async (reviewId) => {
  const docRef = doc(db, "reviews", "AllReviews");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    delete data[reviewId];
    await setDoc(docRef, data);
  }
};